//src/styles/custom/index.js
import borders from "./borders";
import shadows from "./shadows";
import transitions from "./transitions";
import spacing from "./spacing";
import box from "./box";

const custom = {
  borders,
  shadows,
  transitions,
  spacing,
  box,
};

export default custom;